import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShapingMachineHorizontal = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 60,
	viewBox: "0 0 100.0 60.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 80.0 0.0 L 90.0 20.0 L 100.0 20.0 L 100.0 40.0 L 90.0 40.0 L 80.0 60.0 L 0.0 60.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgShapingMachineHorizontal;
